export var EmbedDevice;
(function (EmbedDevice) {
    EmbedDevice["DESKTOP"] = "DESKTOP";
    EmbedDevice["ANDROID_PHONE"] = "Android Phone";
    EmbedDevice["ANDROID_TV"] = "androidtv";
    EmbedDevice["IPHONE"] = "iPhone";
    EmbedDevice["IPAD"] = "iPad";
    EmbedDevice["KINDLE"] = "Kindle";
    EmbedDevice["TABLET"] = "Tablet";
    EmbedDevice["MOBILE"] = "Mobile";
    EmbedDevice["EMBEDDED"] = "Embedded";
    EmbedDevice["LG_WEB_OS"] = "lg-webos";
    EmbedDevice["LG_NETCAST"] = "lg-netcast";
    EmbedDevice["VIZIO_SMART_TV"] = "vizio";
    EmbedDevice["SAMSUNG_SMART_TV"] = "samsung-orsay";
    EmbedDevice["SAMSUNG_TIZEN"] = "samsung-tizen";
    EmbedDevice["SAMSUNG"] = "samsung";
    EmbedDevice["COMCAST"] = "comcast";
    EmbedDevice["XBOX_ONE"] = "xboxone";
    EmbedDevice["CHROMECAST"] = "Chromecast";
    EmbedDevice["PS4"] = "ps4";
    EmbedDevice["PS5"] = "ps5";
    EmbedDevice["TCL"] = "tcl";
    EmbedDevice["COX"] = "cox";
    EmbedDevice["SONY_HTML5"] = "sony";
    EmbedDevice["NETGEM"] = "netgem";
    EmbedDevice["SAGEM"] = "sagem";
    EmbedDevice["VIDAA"] = "vidaa";
    EmbedDevice["TIVO"] = "tivo";
    EmbedDevice["FIRETV"] = "firetv";
    EmbedDevice["UNKNOWN"] = "unknown";
})(EmbedDevice || (EmbedDevice = {}));
